<template>
  <div id="join-popup">
    <transition name="fade">
      <form class="description-popup" v-if="form1" v-on:submit.prevent="onSubmit1">
        <div class="popup welcome">
          <div class="img-header"></div>
          <div class="detail-popup text-center">
            <p>WELCOME TO ENWOKE</p>
            <p>THE ENWOKE social commerce solution helps you connect with a world of professional networks, find content for your websites and contribute your own stories. Please follow these steps to set-up your ENWOKE account and help your with the features of the platform. You can also skip the assistant and restart it at a later time from the settings menu.</p>
            <p>
              <input
                type="email"
                class="input-popup"
                placeholder="Email address"
                v-model="form1Data.email"
              />
            </p>
            <div
              v-if="isExistsEmail"
              class="alert alert-danger"
              role="alert"
            >This email is already exists.</div>
            <p>
              <label for="ck">
                <input type="checkbox" id="ck" v-model="form1Data.isAccepted" />
                I agree to the ENWOKE terms & conditions
              </label>
            </p>
          </div>
        </div>
        <div class="confirm-btn">
          <span @click="close">CANCEL</span>
          <button
            type="submit"
            class="btn-continue"
            :disabled="!form1Data.isAccepted || !form1Data.email"
          >
            CONTINUE SETUP &nbsp;&nbsp;&nbsp;
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </form>
    </transition>
    <transition name="fade">
      <form class="description-popup" v-if="form2" v-on:submit.prevent="onSubmit2">
        <div class="popup business-detail">
          <p>PERSONAL DETAILS</p>
          <div class="form-input">
            <input
              type="text"
              class="input-form"
              placeholder="First name"
              v-model="form2Data.firstName"
            />
          </div>
          <div class="form-input">
            <input
              type="text"
              class="input-form"
              placeholder="Surname"
              v-model="form2Data.lastName"
            />
          </div>
          <div class="form-input">
            <div class="group-form">
              <!-- <select class="input-form group-prepend">
                <option value>+66</option>
              </select>-->
              <input
                type="text"
                class="input-form"
                placeholder="Telephone Number"
                v-model="form2Data.telephone"
              />
            </div>
          </div>
          <div class="form-input" v-if="$store.state.ref && $store.state.ref.countries">
            <select class="input-form" v-model="form2Data.country">
              <option value>Country</option>
              <option
                v-for="country in $store.state.ref.countries"
                :key="country.id"
                :value="country.id"
              >{{country.title}}</option>
            </select>
          </div>
          <div class="form-input">
            <input type="text" class="input-form" placeholder="City" v-model="form2Data.city" />
          </div>
          <!-- <div class="form-input mt-4">
            <label class="input-radio">
              <input type="radio" name="business" :value="true" required>
              <div class="checkmark"></div>I am representing a business
            </label>
          </div>
          <div class="form-input">
            <label class="input-radio">
              <input type="radio" name="business" :value="false" required>
              <div class="checkmark"></div>I work freelance and don't have a registered business
            </label>
          </div>-->
        </div>
        <div class="confirm-btn">
          <span @click="skip">CANCEL</span>
          <button type="submit" class="btn-continue">
            NEXT &nbsp;&nbsp;&nbsp;
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </form>
    </transition>
    <transition name="fade">
      <form class="description-popup" v-if="form3" v-on:submit.prevent="onSubmit3">
        <div class="popup business-detail">
          <p>BUSINESS DETAILS</p>
          <div class="form-input">
            <input
              type="text"
              class="input-form"
              placeholder="Business Name"
              v-model="form3Data.name"
            />
          </div>
          <div class="form-input">
            <input
              type="text"
              class="input-form"
              placeholder="Registration Number"
              v-model="form3Data.registrationNumber"
            />
          </div>
          <div class="form-input">
            <textarea class="input-form" placeholder="Address" rows="3" v-model="form3Data.address"></textarea>
          </div>
          <div class="form-input">
            <input
              type="text"
              class="input-form"
              placeholder="Postal Code"
              v-model="form3Data.postalCode"
            />
          </div>
          <div class="form-input">
            <input type="text" class="input-form" placeholder="CIty" v-model="form3Data.city" />
          </div>
          <div class="form-input" v-if="$store.state.ref && $store.state.ref.industries">
            <select class="input-form" v-model="form3Data.industry">
              <option value>Industry</option>
              <option
                v-for="industry in $store.state.ref.industries"
                :key="industry.id"
                :value="industry.id"
              >{{industry.title}}</option>
            </select>
          </div>
          <div class="form-input" v-if="$store.state.ref && $store.state.ref.countries">
            <select class="input-form" v-model="form3Data.country">
              <option value>Country</option>
              <option
                v-for="country in $store.state.ref.countries"
                :key="country.id"
                :value="country.id"
              >{{country.title}}</option>
            </select>
          </div>
        </div>
        <div class="confirm-btn">
          <span @click="skip">SKIP</span>
          <button type="submit" class="btn-continue">
            NEXT &nbsp;&nbsp;&nbsp;
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </form>
    </transition>
    <transition name="fade">
      <div class="verify-message" v-if="showVerifyMessage === true">
        <p>
          Thank you for registering to ENWOKE.
          <br />Please check your email account to complete the registration process
        </p>
        <div class="close-button" @click="onClose">Close</div>
      </div>
    </transition>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import imgChose1 from "@/assets/images/img-chose-1.jpg";
import imgChose2 from "@/assets/images/img-chose-2.jpg";
import imgChose3 from "@/assets/images/img-chose-3.jpg";

export default {
  name: "join-popup",
  data() {
    return {
      isExistsEmail: false,
      loggedInId: null,
      form1Data: {
        email: "",
        isAccepted: false
      },
      form2Data: {
        firstName: "",
        lastName: "",
        telephone: "",
        city: "",
        country: "",
        address: ""
      },
      form3Data: {
        name: "",
        registrationNumber: "",
        address: "",
        city: "",
        postalCode: "",
        country: "",
        industry: ""
      },
      form1: true,
      form2: false,
      form3: false,
      showVerifyMessage: false,
      business: null,
      imgChose: [imgChose1, imgChose2, imgChose3]
    };
  },
  methods: {
    onSubmit1() {
      if (!this.form1Data.isAccepted || !this.form1Data.email) return;

      this.$repo.user
        .isExistsBusinessUserEmail(this.form1Data.email)
        .then(isExistsBusinessUserEmail => {
          this.isExistsEmail = isExistsBusinessUserEmail;

          if (!isExistsBusinessUserEmail) {
            this.form1 = false;
            this.form2 = true;
            this.form3 = false;
          }
        })
        .catch(_ => {
          console.log("Something went wrong while check email availability.");
        });
    },
    onSubmit2() {
      this.form1 = false;
      this.form2 = false;
      this.form3 = true;
    },
    onSubmit3() {
      this.finish();
    },
    skip() {
      this.finish();
    },
    finish() {
      const user = {
        email: this.form1Data.email,
        firstName: this.form2Data.firstName,
        lastName: this.form2Data.lastName,
        telephone: this.form2Data.telephone,
        city: this.form2Data.city,
        country: this.form2Data.country,
        address: this.form2Data.address,
        business: {
          name: this.form3Data.name,
          registrationNumber: this.form3Data.registrationNumber,
          address: this.form3Data.address,
          city: this.form3Data.city,
          postalCode: this.form3Data.postalCode,
          country: this.form3Data.country,
          industry: this.form3Data.industry
        }
      };

      const activateUrl = `${window.location.protocol}//${window.location.hostname}/account/activate`;
      this.$repo.user.signup(user, activateUrl).then(user => {
        this.business = 1;
        this.form1 = false;
        this.form2 = false;
        this.form3 = false;
        this.showVerifyMessage = true;
      });
    },
    onClose() {
      this.$router.push("/dashboard");
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
#join-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);

  .description-popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .popup {
      background-color: #fff;

      &.welcome {
        width: 878px;
        height: 512px;

        .img-header {
          width: 100%;
          height: 217px;
          background-image: url("../assets/images/bg-header-popup.jpg");
          background-size: cover;
          background-repeat: no-repeat;
        }

        .detail-popup {
          padding: 37px 30px;

          p {
            color: #58595b;
            font-size: 14px;

            &:nth-child(1) {
              font-size: 36px;
            }

            .input-popup {
              width: 380px;
              font-size: 12px;
              padding: 15px;
            }
          }
        }
      }

      &.business-detail {
        width: 434px;
        //height: 478px;
        padding: 30px 25px;
      }

      &.you-are-all-set {
        width: 737px;
        height: 444px;
        padding: 30px 30px;

        p {
          font-size: 24px;
          color: #58595b;
          margin-bottom: 30px;
        }

        .chose {
          margin: -15px;
          display: flex;

          .list-chose {
            width: 33.33%;
            padding: 0 15px;

            .description {
              box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
              height: 100%;

              img {
                width: 100%;
              }

              .detail-chose {
                font-size: 14px;
                color: #58595b;
                padding: 15px 15px 0;
              }
            }
          }
        }
      }

      .form-input {
        width: 100%;
        margin-bottom: 8px;

        .group-form {
          display: flex;

          .group-prepend {
            width: 80px;
          }
        }

        .input-radio {
          display: block;
          position: relative;
          padding-left: 35px;
          margin-bottom: 12px;
          cursor: pointer;
          font-size: 12px;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;

          .checkmark {
            position: absolute;
            top: 2px;
            left: 9px;
            height: 15px;
            width: 15px;
            background-color: #fff;
            border: 1px #b9b9b9 solid;
            border-radius: 50%;

            &:after {
              content: "";
              position: absolute;
              display: none;
              top: -1px;
              left: -1px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: var(--primary-color);
            }
          }

          input {
            position: absolute;
            opacity: 0;
            cursor: pointer;

            &:checked ~ .checkmark:after {
              display: block;
            }
          }

          &:hover {
            input ~ .checkmark {
              background-color: #ccc;
            }
          }
        }

        input,
        select {
          &.input-form {
            width: 100%;
            height: 36px;
            font-size: 12px;
            padding: 0 15px;
          }
        }

        textarea {
          &.input-form {
            width: 100%;
            height: 60px;
            font-size: 12px;
            padding: 8px 15px;
          }
        }
      }
    }

    .confirm-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;

      span {
        cursor: pointer;
        text-decoration: underline;
        color: #fff;
        padding-right: 78px;
      }

      .todashboard {
        text-decoration: underline;
        color: #fff;
        background-color: transparent;
        border: none;
      }

      .btn-continue {
        background-color: var(--primary-color);
        height: 50px;
        color: #fff;
        font-size: 14px;
        padding: 0 20px;
        border: none;
      }
    }
  }

  .verify-message {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    p {
      font-size: 36px;
      font-weight: bold;
      color: #fff;
      text-shadow: 1px 2px 3px rgba(0, 0, 0, 0.16);
      margin-bottom: 20px;
    }

    .close-button {
      background-color: var(--primary-color);
      color: #fff;
      text-transform: uppercase;
      font-size: 14px;
      padding: 14px 65px;
      display: inline-block;
      margin-top: 20px;
      cursor: pointer;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>


